import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=1457e178&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=ts"
export * from "./SiteMenu.vue?vue&type=script&lang=ts"
import style0 from "./SiteMenu.vue?vue&type=style&index=0&id=1457e178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457e178",
  null
  
)

export default component.exports